import type { CreditNoticeContext, CreditNoticeEvent, CreditNoticeState } from './types';
import { create } from 'zustand';
import { createInitialCreditNoticeState, reduceCreditNoticeState } from './helper';

interface CreditNoticeStore extends CreditNoticeState {
  applyEvent: (
    event: CreditNoticeEvent | null,
    context: CreditNoticeContext,
    options?: { deferSummary?: boolean },
  ) => boolean;
  releasePriority: () => void;
  reset: () => void;
  clearSummaryReveal: () => void;
}

export const useCreditNoticeStore = create<CreditNoticeStore>((set, get) => ({
  ...createInitialCreditNoticeState(),

  applyEvent: (event, context, options) => {
    const currentState = get();
    const nextState = reduceCreditNoticeState(currentState, event, context, options);
    if (nextState === currentState) {
      return false;
    }

    set(nextState);
    return true;
  },

  releasePriority: () => {
    const currentState = get();
    set({
      status: 'idle',
      event: null,
      hasPriority: false,
      ignoredMessageId: currentState.event?.noticeId ?? currentState.ignoredMessageId,
      summaryReveal: null,
    });
  },

  clearSummaryReveal: () => set({ summaryReveal: null }),

  reset: () => set(createInitialCreditNoticeState()),
}));

export type {
  CreditNoticeContext,
  CreditNoticeEvent,
  CreditNoticeEventStatus,
  CreditNoticeNextStep,
  CreditNoticeState,
  CreditNoticeStatus,
} from './types';
